module.exports = __webpack_public_path__ + "static/media/close-icon.0ea24b9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/close-icon.svg
// module id = 1784
// module chunks = 27